import { render, staticRenderFns } from "./DeliveryChart.vue?vue&type=template&id=27fa5bc3&scoped=true&"
import script from "./DeliveryChart.vue?vue&type=script&lang=js&"
export * from "./DeliveryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa5bc3",
  null
  
)

export default component.exports